<div class="form-group">
    <label>{{ 'Catalogue values:' | translate }}</label>
    <select class="form-control"
            name="classificationType"
            [ngModel]="guide?.classification?.id"
            (ngModelChange)="classificationChanged($event)">
    <option *ngFor="let classification of classificationsList" value="{{classification.id}}"
            [selected]="guide?.classification?.id === classification.id">{{classification.name}}
    </option>
  </select>
</div>

<div class="form-group" *ngIf="catalogGroups.length > 0">
    <label>{{ 'Group values:' | translate }} </label>
    <select class="form-control"
            name="catalogGroup"
            [ngModel]="guide?.catalogGroupId"
            (ngModelChange)="groupChanged($event)">
        <option value="">None</option>
        <option *ngFor="let group of catalogGroups" value="{{group.id}}"
                [selected]="guide?.catalogGroupId === group.id">{{group.name}}
        </option>
  </select>
</div>

<div class="form-group"
     *ngIf="guides && guide.parentQuestionId">
    <label>{{ 'Parent Catalogues list:' | translate }} </label>
    <select class="form-control"
            name="parentClassificationFieldKey"
            (ngModelChange)="selectedParent($event)"
            [(ngModel)]="guide.parentQuestionId">
    <option value="">None</option>
    <option *ngFor="let parentClassification of classificationFields" value="{{parentClassification.id}}"
                [selected]="guide.parentQuestionId === parentClassification.id">
            {{parentClassification.title}}
    </option>
  </select>
</div>
